import React, { useState } from 'react';
import { ListRequestsProps } from './types';
import { sortRequestByCreateDate } from '@widgets/buy-manager-order/lib/utils/sort-request-by-create-date/sort-request-by-create-date';
import { CardUserRequest } from '../card-user-request/card-user-request';
import { UserPreview } from '@shared/model/user';
import { ModalEmployeeListItemMoreInfo } from '@entities/employee/employee-list-item-more-info/ui/modal-employee-list-item-more-info';

export const ListRequests: React.FC<ListRequestsProps> = ({ order, refetchOrder }) => {
    const [modalUser, setModalUser] = useState<UserPreview | null>(null);

    const handleClickUserCard = (user: UserPreview) => () => {
        setModalUser(user);
    };

    return (
        <>
            {sortRequestByCreateDate(order.requests).map((request) => (
                <CardUserRequest
                    key={request.id}
                    request={request}
                    order={order}
                    isLastRequest={order.requests.length === 1}
                    onUpdateCount={refetchOrder}
                    onRemoveUser={refetchOrder}
                    onClick={handleClickUserCard(request.user)}
                />
            ))}
            <ModalEmployeeListItemMoreInfo
                isShow={Boolean(modalUser?.id)}
                userId={modalUser?.id || 0}
                onClose={() => setModalUser(null)}
            />
        </>
    );
};
